import IAction from "models/IAction";
import BaseHeaderOptionModel from "stores/shared/models/BaseHeaderOptionModel";
import BaseReducer from "../../utilities/BaseReducer";
import CercaAction from "./CercaHeaderAction";
import ICercaHeaderState from "./models/ICercaHeaderState";
import SearchModel from './models/SearchModel';

export default class CercaHeaderReducer extends BaseReducer<ICercaHeaderState> {
    public readonly initialState: ICercaHeaderState = {
        search: new SearchModel({}),
        form: new BaseHeaderOptionModel({})
    };

    public [CercaAction.REQUEST_HEADER_SEARCH_FINISHED](
        state: ICercaHeaderState,
        action: IAction<SearchModel>
    ): ICercaHeaderState {
        return {
            ...state,
            search: action.payload!,
        };
    }

    public [CercaAction.REQUEST_HEADER_SET_FORM_VALUE](
        state: ICercaHeaderState,
        action: IAction<BaseHeaderOptionModel>
    ): ICercaHeaderState {
        return {
            ...state,
            form: action.payload!
        };
    }

}
